<form [formGroup]="formGroup">
  <app-required-fields />

  <div>
    <bricks-card>
      <h3>
        <span>
          Wer ist der Vertragspartner?
          <app-required-asterisk />
        </span>
      </h3>

      <div class="group-wrapper card-custom__item">
        @for (option of contractLogic.contractPartnerOptions; track option) {
          <div>
            <input
              [id]="`radio-contract-partner-${option.value}`"
              class="bricks-input"
              type="radio"
              name="contractPartner"
              [formControl]="formGroup.controls.contractPartner"
              [value]="option.value"
              (change)="contractLogic.contractPartnerSignal.set(option.value)"
              [class.error]="
                formGroup.controls.contractPartner.hasError('required') && formGroup.controls.contractPartner.touched
              " />
            <label [for]="`radio-contract-partner-${option.value}`" class="density">
              {{ option.label }}
            </label>
          </div>
        }
      </div>

      @if (formGroup.controls.contractPartner.value === contractLogic.ContractPartner.Company) {
        <div class="group-wrapper">
          <h4>Handelsregister</h4>
          <div class="flex-row">
            <div class="flex-col-50">
              <bricks-input-dropdown
                [showResetOption]="true"
                [label]="'Registertyp'"
                [placeholder]="'Bitte auswählen'"
                [formControl]="formGroup.controls.registrationType"
                [width]="'fill'">
                @for (type of registerTypes; track type) {
                  <bricks-option [value]="type">
                    {{ type }}
                  </bricks-option>
                }
              </bricks-input-dropdown>
            </div>
          </div>
          <div class="flex-row register-fields-row">
            <div class="flex-col-50">
              <bricks-input
                class="register-number-field"
                [showResetOption]="true"
                width="fill"
                [label]="'Registernummer'"
                [subscriptSizing]="'dynamic'"
                [formControl]="formGroup.controls.registrationNumber"
                (input)="inputRestrictions.sanitizeRegistrationNumberInput($event)"
                (focusout)="onRegistrationNumberBlur($event)">
                @if (formGroup.controls.registrationNumber.hasError('registrationNumberFormat')) {
                  <bricks-error>{{ registrationNumberFormatError }}</bricks-error>
                }
              </bricks-input>
            </div>
            <div class="flex-col-50">
              <bricks-input-autocomplete
                [showResetOption]="true"
                label="Registergericht"
                [placeholder]="'Bitte auswählen'"
                [formControl]="formGroup.controls.registrationAuthorityName"
                [options]="registrationAuthorityNames"
                width="fill">
              </bricks-input-autocomplete>
            </div>
          </div>
          <div class="flex-row">
            <div class="register-actions">
              <button
                type="button"
                id="fetchCommercialRegisterData"
                class="bricks-button button-fn button-icon-left"
                [disabled]="isFetchCommercialRegisterDataButtonDisabled()"
                (click)="fetchCommercialRegisterData()">
                <bricks-icon>bricks-load-1</bricks-icon>
                <span>Firmendaten aus Handelsregister abrufen</span>
              </button>
              @if (isCommercialRegisterDataApplied()) {
                <button
                  type="button"
                  id="resetCommercialRegisterData"
                  class="bricks-button button-fn-secondary button-icon-left"
                  (click)="resetCommercialRegisterData()">
                  <bricks-icon>bricks-close-circle</bricks-icon>
                  <span>Zurücksetzen</span>
                </button>
              }
            </div>
          </div>
        </div>
        <h4>Firmendaten</h4>
        <div class="flex-row">
          <div class="flex-col-50">
            <bricks-input
              id="contractOwnerName"
              [showResetOption]="!isContractOwnerNameDisabled()"
              [label]="'Firmenname'"
              [formControl]="formGroup.controls.contractOwnerName"
              width="fill"
              [isRequired]="true"
              [disabled]="isContractOwnerNameDisabled()">
              @if (formGroup.controls.contractOwnerName.hasError('maxlength')) {
                <bricks-error>
                  Es sind maximal
                  {{ formGroup.controls.contractOwnerName.errors?.['maxlength']?.requiredLength }}
                  Zeichen erlaubt.
                </bricks-error>
              }
            </bricks-input>
          </div>
        </div>
      }
      @if (formGroup.controls.contractPartner.value === contractLogic.ContractPartner.Person) {
        <div class="flex-row">
          <div class="flex-col-50">
            <bricks-input
              [showResetOption]="true"
              id="firstname"
              [label]="'Vorname'"
              [formControl]="formGroup.controls.firstName"
              width="fill"
              [isRequired]="true"
              (input)="inputRestrictions.sanitizeNameInput($event)">
              @if (formGroup.controls.firstName.hasError('maxlength')) {
                <bricks-error>
                  Es sind maximal
                  {{ formGroup.controls.firstName.errors?.['maxlength']?.requiredLength }}
                  Zeichen erlaubt.
                </bricks-error>
              }
            </bricks-input>
          </div>
          <div class="flex-col-50">
            <bricks-input
              id="lastname"
              [showResetOption]="true"
              [label]="'Nachname'"
              [formControl]="formGroup.controls.lastName"
              width="fill"
              [isRequired]="true"
              (input)="inputRestrictions.sanitizeNameInput($event)">
              @if (formGroup.controls.lastName.hasError('maxlength')) {
                <bricks-error>
                  Es sind maximal
                  {{ formGroup.controls.lastName.errors?.['maxlength']?.requiredLength }}
                  Zeichen erlaubt.
                </bricks-error>
              }
            </bricks-input>
          </div>
        </div>
      }

      <div class="flex-row">
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="!isAddressPostalCodeDisabled()"
            [label]="'PLZ'"
            [formControl]="formGroup.controls.addressPostalCode"
            width="fill"
            [isRequired]="true"
            [disabled]="isAddressPostalCodeDisabled()"
            (cleared)="addressLogic.resetFullAddress()"
            (input)="addressLogic.onPostalCodeInput($event)">
            @if (formGroup.controls.addressPostalCode.errors) {
              <bricks-error>{{ getAddressPostalCodeError(formGroup.controls.addressPostalCode) }}</bricks-error>
            }
          </bricks-input>
        </div>
        <div class="flex-col-50">
          <!-- Show input field when there's 0 or 1 city -->
          @if (addressLogic.shouldShowCityInput()) {
            <bricks-input
              [showResetOption]="!addressLogic.isCityReadonly()"
              [label]="'Ort'"
              [formControl]="formGroup.controls.addressCity"
              width="fill"
              [isRequired]="true"
              [disabled]="addressLogic.isCityReadonly() || isAddressCityDisabled()">
            </bricks-input>
          }

          <!-- Show dropdown when there are multiple cities -->
          @if (addressLogic.shouldShowCityDropdown()) {
            <bricks-input-dropdown
              [showResetOption]="true"
              label="Ort"
              [formControl]="formGroup.controls.addressCity"
              [isRequired]="true"
              width="fill">
              @for (city of addressLogic.citiesSignal(); track city) {
                <bricks-option [value]="city">
                  {{ city }}
                </bricks-option>
              }
            </bricks-input-dropdown>
          }
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-col-50">
          <!-- Show input field when there's 0 or 1 street -->
          @if (addressLogic.shouldShowStreetInput()) {
            <bricks-input
              [showResetOption]="!addressLogic.isStreetReadonly()"
              [label]="'Straße'"
              [formControl]="formGroup.controls.addressStreet"
              width="fill"
              [isRequired]="true"
              [disabled]="addressLogic.isStreetReadonly() || isAddressStreetDisabled()">
              @if (formGroup.controls.addressStreet.errors) {
                <bricks-error>{{ getAddressStreetError(formGroup.controls.addressStreet) }}</bricks-error>
              }
            </bricks-input>
          }

          <!-- Show autocomplete when there are multiple streets -->
          @if (addressLogic.shouldShowStreetDropdown()) {
            <bricks-input-autocomplete
              [showResetOption]="true"
              label="Straße"
              [formControl]="formGroup.controls.addressStreet"
              [isRequired]="true"
              [options]="addressLogic.streetsSignal()"
              width="fill">
              @if (formGroup.controls.addressStreet.errors) {
                <bricks-error>{{ getAddressStreetError(formGroup.controls.addressStreet) }}</bricks-error>
              }
            </bricks-input-autocomplete>
          }
        </div>

        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="!isAddressHouseNumberDisabled()"
            [label]="'Hausnummer'"
            [formControl]="formGroup.controls.addressHouseNumber"
            width="fill"
            [isRequired]="true"
            [disabled]="isAddressHouseNumberDisabled()">
            @if (formGroup.controls.addressHouseNumber.hasError('maxlength')) {
              <bricks-error>
                Es sind maximal
                {{ formGroup.controls.addressHouseNumber.errors?.['maxlength']?.requiredLength }}
                Zeichen erlaubt.
              </bricks-error>
            }
          </bricks-input>
        </div>
      </div>

      <h3>
        <span> Ansprechpartner </span>
      </h3>

      <div class="flex-row">
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="true"
            id="contactInfoFirstName"
            [label]="'Vorname'"
            [formControl]="formGroup.controls.contactInfoFirstName"
            width="fill"
            [isRequired]="true"
            (input)="inputRestrictions.sanitizeNameInput($event)">
            @if (formGroup.controls.contactInfoFirstName.hasError('maxlength')) {
              <bricks-error>
                Es sind maximal
                {{ formGroup.controls.contactInfoFirstName.errors?.['maxlength']?.requiredLength }}
                Zeichen erlaubt.
              </bricks-error>
            }
          </bricks-input>
        </div>
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="true"
            id="contactInfoLastName"
            [label]="'Nachname'"
            [formControl]="formGroup.controls.contactInfoLastName"
            width="fill"
            [isRequired]="true"
            (input)="inputRestrictions.sanitizeNameInput($event)">
            @if (formGroup.controls.contactInfoLastName.hasError('maxlength')) {
              <bricks-error>
                Es sind maximal
                {{ formGroup.controls.contactInfoLastName.errors?.['maxlength']?.requiredLength }}
                Zeichen erlaubt.
              </bricks-error>
            }
          </bricks-input>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="true"
            [label]="'Telefonnummer'"
            [formControl]="formGroup.controls.contactInfoPhone"
            width="fill"
            [isRequired]="true"
            (input)="inputRestrictions.sanitizePhoneInput($event)">
            @if (formGroup.controls.contactInfoPhone.hasError('maxlength')) {
              <bricks-error>
                Es sind maximal
                {{ formGroup.controls.contactInfoPhone.errors?.['maxlength']?.requiredLength }}
                Zeichen erlaubt.
              </bricks-error>
            }
          </bricks-input>
        </div>
        <div class="flex-col-50">
          <bricks-input
            [showResetOption]="true"
            [label]="'E-Mail'"
            [formControl]="formGroup.controls.contactInfoEmail"
            width="fill"
            [isRequired]="true">
            @if (formGroup.controls.contactInfoEmail.hasError('pattern')) {
              <bricks-error>
                Bitte geben Sie eine gültige E-Mail-Adresse an (z. B. vorname.nachname&#64;email.de).
              </bricks-error>
            }
          </bricks-input>
        </div>
      </div>

      <input
        id="checkbox-data-protection"
        class="bricks-input"
        type="checkbox"
        [formControl]="formGroup.controls.dataProtectionAccepted"
        [class.error]="
          formGroup.controls.dataProtectionAccepted.hasError('required') &&
          formGroup.controls.dataProtectionAccepted.touched
        " />
      <label for="checkbox-data-protection" class="density">
        <span>
          Ich habe die
          <a href="/legal/datenschutzinformationen-direktvermarktung-von-strom-aus-eeg-anlagen.pdf" target="_blank"
            >Datenschutzerklärung</a
          >
          gelesen und akzeptiere, dass meine personenbezogenen Daten vom Vertragspartner EnBW Energie Baden-Württemberg
          AG zum Zweck der Angebotserstellung gemäß Art. 6 Abs. 1 lit. b) DSGVO gespeichert und verarbeitet werden.
          <app-required-asterisk />
        </span>
      </label>
      @if (
        formGroup.controls.dataProtectionAccepted.hasError('required') &&
        formGroup.controls.dataProtectionAccepted.touched
      ) {
        <bricks-error>Bitte akzeptieren Sie die Datenschutzerklärung.</bricks-error>
      }
    </bricks-card>

    <bricks-alert
      class="bricks-alert-full-width"
      title="Durch das Absenden dieses Formulars übermitteln Sie Ihre Anfrage an unser Team."
      description="Auf Grundlage Ihrer Angaben erstellt unser Team ein individuelles Vermarktungsangebot. Sie erhalten das Angebot per E-Mail."
      type="info-outline"
      [isClosable]="false"></bricks-alert>
    <bricks-card>
      <div class="flex-row space-between">
        <button type="button" class="bricks-button button-fn-no-background button-icon-left" (click)="onBack()">
          <bricks-icon>bricks-chevron-small-left</bricks-icon>
          <span>Zurück</span>
        </button>
        <button
          id="contactSubmit"
          type="submit"
          class="bricks-button button-fn button-icon-right"
          (click)="onSubmit(); trackEvent()">
          <span>Individuelles Angebot anfordern</span>
          <bricks-icon>bricks-send-message</bricks-icon>
        </button>
      </div>
    </bricks-card>
  </div>
</form>
